/* paginagewicht 2026-11-04: scripts die op elke pagina meeliepen. Geladen met defer: ze draaien na het inlezen van de HTML, in deze volgorde. */

/* ---- uit snippets/rabe-landkiezer ---- */
;(function () {
    if (window.__rabeLandkiezer) return;
    window.__rabeLandkiezer = true;
    function init(root) {
      var knop = root.querySelector('.rabe-lk__knop');
      var menu = root.querySelector('.rabe-lk__menu');
      if (!knop || !menu) return;
      function open() { menu.hidden = false; knop.setAttribute('aria-expanded', 'true'); root.classList.add('is-open'); }
      function sluit(focus) {
        if (menu.hidden) return;
        menu.hidden = true; knop.setAttribute('aria-expanded', 'false'); root.classList.remove('is-open');
        if (focus) knop.focus();
      }
      knop.addEventListener('click', function () { if (menu.hidden) { open(); } else { sluit(false); } });
      root.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') { if (!menu.hidden) { e.preventDefault(); sluit(true); } }
      });
      root.addEventListener('focusout', function (e) {
        if (e.relatedTarget && !root.contains(e.relatedTarget)) sluit(false);
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) sluit(false); });
    }
    function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-rabe-lk]'), init); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
  })();

/* ---- uit snippets/rabe-acc-menu ---- */
;(function () {
    var root = document.querySelector('[data-racc-menu]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var btn = root.querySelector('.racc-m__btn');
    var panel = root.querySelector('.racc-m__panel');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var tOpen, tClose;
    function place() {
      if (window.innerWidth <= 640) { panel.style.top = (btn.getBoundingClientRect().bottom + 8) + 'px'; panel.style.right = ''; return; }
      panel.style.top = '';
      /* rechterrand van het menu gelijk met de rechterrand van de headerknoppen (winkelwagen), pijltje boven deze knop */
      var act = root.closest('.header-actions') || root.parentNode;
      var rr = root.getBoundingClientRect(), ar = act.getBoundingClientRect(), br = btn.getBoundingClientRect();
      var off = Math.max(0, Math.round(ar.right - rr.right));
      panel.style.right = (-off) + 'px';
      panel.style.setProperty('--racc-caret', Math.round(off + br.width / 2 - 7) + 'px');
    }
    function open() {
      clearTimeout(tClose);
      if (!panel.hidden) return;
      place(); panel.hidden = false; btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      clearTimeout(tOpen);
      if (panel.hidden) return;
      panel.hidden = true; btn.setAttribute('aria-expanded', 'false');
    }
    btn.addEventListener('click', function (e) {
      if (fine.matches) return;            /* muis: de knop gaat gewoon naar Mijn account */
      e.preventDefault();
      if (panel.hidden) open(); else close();
    });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === ' ') {
        e.preventDefault(); open();
        var first = panel.querySelector('a'); if (first) first.focus();
      }
    });
    root.addEventListener('mouseenter', function () { if (!fine.matches) return; clearTimeout(tClose); tOpen = setTimeout(open, 120); });
    root.addEventListener('mouseleave', function () { if (!fine.matches) return; clearTimeout(tOpen); tClose = setTimeout(close, 300); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) close(); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) { close(); btn.focus(); } });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); });
  })();

/* ---- uit sections/rabe-header (mobiel menu) ---- */
;(() => {
    // 2026-10-27 mobiel menu. De inhoud wordt bij de eerste klik opgebouwd uit de bestaande navigatie:
    // hoofdkoppen en megamenu's (.site-nav), servicelinks (.site-nav__utility), landkiezer (.rabe-lk)
    // en account (.racc-m__btn). Zo blijft de lade altijd gelijk aan het desktopmenu, in NL en DE.
    const header = document.querySelector('.site-header');
    const root = document.querySelector('[data-rmm]');
    const knop = header && header.querySelector('.rmm-btn');
    if (!header || !root || !knop) return;
    header.classList.add('rmm-on');
    const lade = root.querySelector('.rmm__lade');
    const inhoud = root.querySelector('[data-rmm-inhoud]');
    const L_SUB = root.getAttribute('data-l-sub') || '';
    const CHEV = '<svg class="rmm__chev" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"></path></svg>';
    const PIJL = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M5 12h14"></path><path d="m13 5 7 7-7 7"></path></svg>';
    const ACC = '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"></circle><path d="M4 21a8 8 0 0 1 16 0"></path></svg>';
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // breekpunt: 1120px, op /de 1279px (data-bp, gelijk aan de CSS)
    const bp = parseInt(root.getAttribute('data-bp'), 10) || 1120;
    const mq = window.matchMedia ? window.matchMedia('(max-width: ' + bp + 'px)') : null;
    let gebouwd = false;
    let open = false;
    let sluitTimer = 0;
    let uid = 0;
    const el = (tag, cls, attrs) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (attrs) Object.keys(attrs).forEach((k) => n.setAttribute(k, attrs[k]));
      return n;
    };
    const tekst = (n) => (n ? n.textContent.replace(/\s+/g, ' ').trim() : '');
    const kloon = (n) => {
      const c = n.cloneNode(true);
      c.removeAttribute('id');
      c.querySelectorAll('[id]').forEach((x) => x.removeAttribute('id'));
      return c;
    };
    const koppel = (toggle, paneel, groep) => {
      const id = 'rmm-p' + (++uid);
      paneel.id = id;
      paneel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', id);
      toggle.addEventListener('click', () => {
        const nu = toggle.getAttribute('aria-expanded') !== 'true';
        if (nu && groep) groep.forEach((t) => {
          if (t !== toggle && t.getAttribute('aria-expanded') === 'true') {
            t.setAttribute('aria-expanded', 'false');
            const p = document.getElementById(t.getAttribute('aria-controls'));
            if (p) p.hidden = true;
          }
        });
        toggle.setAttribute('aria-expanded', nu ? 'true' : 'false');
        paneel.hidden = !nu;
        if (nu && toggle.scrollIntoView) toggle.scrollIntoView({ block: 'nearest' });
      });
    };
    const bouw = () => {
      if (gebouwd) return;
      gebouwd = true;
      const nav = header.querySelector('.site-nav');
      const voorbij = document.documentElement.classList.contains('hw-voorbij');
      const cats = el('ul', 'rmm__cats', { role: 'list' });
      const catKnoppen = [];
      if (nav) nav.querySelectorAll(':scope > .site-nav__item').forEach((item) => {
        const a = item.querySelector(':scope > .site-nav__link');
        if (!a) return;
        const naam = tekst(a.querySelector('span') || a);
        const hw = voorbij ? null : a.querySelector('.hw-nav-pk');
        const mega = item.querySelector(':scope > .mega-menu');
        const groepen = mega ? mega.querySelectorAll('.mega-menu__group') : [];
        const li = el('li', 'rmm__cat');
        const s = el('span');
        s.textContent = naam;
        if (hw) s.appendChild(kloon(hw));
        if (!groepen.length) {
          const l = el('a', 'rmm__rij', { href: a.getAttribute('href') });
          l.appendChild(s);
          li.appendChild(l);
          cats.appendChild(li);
          return;
        }
        const t = el('button', 'rmm__rij', { type: 'button' });
        t.appendChild(s);
        t.insertAdjacentHTML('beforeend', CHEV);
        const paneel = el('div', 'rmm__sub');
        const intro = mega.querySelector('.mega-menu__intro');
        if (intro) intro.querySelectorAll(':scope > a').forEach((x) => {
          if (x.hasAttribute('data-hw') || x.classList.contains('hw-mega')) {
            if (!voorbij) paneel.appendChild(kloon(x));
            return;
          }
          const l = el('a', 'rmm__alles', { href: x.getAttribute('href') });
          const ls = el('span');
          ls.textContent = tekst(x);
          l.appendChild(ls);
          l.insertAdjacentHTML('beforeend', PIJL);
          paneel.appendChild(l);
        });
        const gl = el('ul', 'rmm__groepen', { role: 'list' });
        groepen.forEach((g) => {
          const kop = g.querySelector('.mega-menu__heading');
          if (!kop) return;
          const links = Array.from(g.querySelectorAll('.mega-menu__links a'));
          const mix = links.some((x) => !x.classList.contains('mega-menu__nested'));
          const gli = el('li', 'rmm__groep');
          const rij = el('div', 'rmm__groeprij');
          const gk = el('a', 'rmm__glink', { href: kop.getAttribute('href') });
          gk.textContent = tekst(kop);
          rij.appendChild(gk);
          gli.appendChild(rij);
          if (links.length) {
            const gt = el('button', 'rmm__gknop', { type: 'button', 'aria-label': (L_SUB + ' ' + tekst(kop)).trim() });
            gt.insertAdjacentHTML('beforeend', CHEV);
            rij.appendChild(gt);
            const sl = el('ul', 'rmm__links', { role: 'list' });
            links.forEach((x) => {
              let cls = 'rmm__link';
              if (x.classList.contains('is-strong')) cls += ' rmm__link--sterk';
              if (mix && x.classList.contains('mega-menu__nested')) cls += ' rmm__link--diep';
              const sli = el('li');
              const l = el('a', cls, { href: x.getAttribute('href') });
              l.textContent = tekst(x);
              sli.appendChild(l);
              sl.appendChild(sli);
            });
            gli.appendChild(sl);
            koppel(gt, sl, null);
          }
          gl.appendChild(gli);
        });
        paneel.appendChild(gl);
        li.appendChild(t);
        li.appendChild(paneel);
        cats.appendChild(li);
        catKnoppen.push(t);
        koppel(t, paneel, catKnoppen);
      });
      inhoud.appendChild(cats);
      const util = nav ? nav.querySelectorAll('.site-nav__utility > a.site-nav__link') : [];
      if (util.length) {
        const ul = el('ul', 'rmm__service', { role: 'list' });
        util.forEach((x) => {
          const li = el('li');
          const l = el('a', 'rmm__rij', { href: x.getAttribute('href') });
          l.textContent = tekst(x);
          li.appendChild(l);
          ul.appendChild(li);
        });
        inhoud.appendChild(ul);
      }
      const lk = header.querySelector('.rabe-lk');
      const lkLijst = lk && lk.querySelector('.rabe-lk__lijst');
      if (lkLijst) {
        const blok = el('div', 'rmm__blok');
        const kop = lk.querySelector('.rabe-lk__kop');
        if (kop) {
          const k = el('p', 'rmm__blokkop');
          k.textContent = tekst(kop);
          blok.appendChild(k);
        }
        blok.appendChild(kloon(lkLijst));
        inhoud.appendChild(blok);
      }
      const acc = header.querySelector('.racc-m__btn');
      if (acc) {
        const l = el('a', 'rmm__rij rmm__account', { href: acc.getAttribute('href') });
        l.insertAdjacentHTML('beforeend', ACC);
        const t = el('span', 'rmm__acctekst');
        const s1 = el('strong');
        s1.textContent = acc.getAttribute('aria-label') || '';
        t.appendChild(s1);
        const l1 = tekst(acc.querySelector('.racc-m__l1'));
        if (l1) {
          const s2 = el('small');
          s2.textContent = l1;
          t.appendChild(s2);
        }
        l.appendChild(t);
        inhoud.appendChild(l);
      }
    };
    const focusbaar = () => Array.from(lade.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter((n) => n.getClientRects().length > 0);
    const openen = () => {
      if (open) return;
      bouw();
      open = true;
      clearTimeout(sluitTimer);
      root.hidden = false;
      const sb = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.classList.add('rmm-lock');
      if (sb > 0) document.body.style.paddingRight = sb + 'px';
      void root.offsetWidth;
      root.classList.add('is-open');
      knop.setAttribute('aria-expanded', 'true');
      const x = root.querySelector('.rmm__sluit');
      (x || lade).focus({ preventScroll: true });
    };
    const sluiten = (terug) => {
      if (!open) return;
      open = false;
      root.classList.remove('is-open');
      knop.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('rmm-lock');
      document.body.style.paddingRight = '';
      const weg = () => { if (!open) root.hidden = true; };
      if (reduce) weg(); else sluitTimer = setTimeout(weg, 260);
      if (terug !== false && knop.getClientRects().length) knop.focus({ preventScroll: true });
    };
    knop.addEventListener('click', () => { if (open) sluiten(); else openen(); });
    root.querySelectorAll('[data-rmm-sluit]').forEach((n) => n.addEventListener('click', () => sluiten()));
    const scrim = root.querySelector('.rmm__scrim');
    if (scrim) {
      scrim.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });
      scrim.addEventListener('wheel', (e) => e.preventDefault(), { passive: false });
    }
    root.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); sluiten(); return; }
      if (e.key !== 'Tab') return;
      const f = focusbaar();
      if (!f.length) { e.preventDefault(); return; }
      const eerste = f[0];
      const laatste = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === eerste || document.activeElement === lade)) { e.preventDefault(); laatste.focus(); }
      else if (!e.shiftKey && document.activeElement === laatste) { e.preventDefault(); eerste.focus(); }
    });
    // vangnet voor de focus-trap: belandt de focus toch buiten de lade, dan terug naar binnen
    document.addEventListener('focusin', (e) => {
      if (open && !lade.contains(e.target)) { const f = focusbaar(); (f[0] || lade).focus({ preventScroll: true }); }
    });
    // breder dan het breekpunt (draaien, venster groter): lade dicht, de gewone navbalk neemt het over
    const breed = () => { if (mq && !mq.matches) sluiten(false); };
    if (mq) { if (mq.addEventListener) mq.addEventListener('change', breed); else if (mq.addListener) mq.addListener(breed); }
    // terug via de browserknop (bfcache): nooit met een open lade en vastgezette pagina terugkomen
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && open) { sluiten(false); clearTimeout(sluitTimer); root.hidden = true; }
    });
  })();

/* ---- uit sections/rabe-header (service) ---- */
;(() => {
    // 2026-09-28 laptopbreedte: Service-uitklapmenu. Muis = CSS :hover, toetsenbord = :focus-visible;
    // aanraken (tablet) en klikken via .is-open. Buiten het menu klikken of Esc sluit het.
    const box = document.querySelector('[data-nav-service]');
    if (!box) return;
    const btn = box.querySelector('.site-nav__service-btn');
    const set = (open) => { box.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false'); };
    btn.addEventListener('click', () => set(!box.classList.contains('is-open')));
    box.addEventListener('pointerleave', (e) => { if (e.pointerType !== 'touch') set(false); });
    // Toetsenbord: open houden zolang de focus binnen het menu blijft (anders valt de focus bij Tab
    // van de knop naar de eerste link weg, omdat het paneel tussen blur en focus heel even dicht is).
    box.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) set(true); });
    box.addEventListener('focusout', (e) => { if (!e.relatedTarget || !box.contains(e.relatedTarget)) set(false); });
    document.addEventListener('click', (e) => { if (!box.contains(e.target)) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && box.classList.contains('is-open')) { set(false); btn.focus(); } });
  })();

/* ---- uit sections/rabe-header (btw) ---- */
;(function () {
  var KEY = 'rabe_btw';
  var de = document.documentElement.lang && document.documentElement.lang.indexOf('de') === 0;
  var LBL = de ? 'exkl. MwSt.' : 'excl. btw';
  var LBL_IN = de ? 'inkl. MwSt.' : 'incl. btw';
  function fmt(cents) { var e = Math.floor(cents / 100), c = cents % 100; var s = e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return '\u20ac' + s + ',' + (c < 10 ? '0' : '') + c; }
  function parse(t) { var m = t.replace(/\s/g, '').match(/(\d{1,3}(?:\.\d{3})*|\d+),(\d{2}|-)/); if (!m) return null; return parseInt(m[1].replace(/\./g, ''), 10) * 100 + (m[2] === '-' ? 0 : parseInt(m[2], 10)); }
  function btns() { return Array.prototype.slice.call(document.querySelectorAll('.js-btw-toggle')); }
  function apply(excl) {
    // productkaarten
    document.querySelectorAll('.product-card .price > span:first-child:not(.quote-price)').forEach(function (el) {
      if (!el.dataset.incl) el.dataset.incl = el.textContent;
      var c = parse(el.dataset.incl); if (c === null) return;
      var pre = /^(Vanaf|Ab)\s/i.exec(el.dataset.incl.trim()); pre = pre ? pre[1] + ' ' : '';
      el.textContent = excl ? pre + fmt(Math.round(c / 1.21)) + ' ' + LBL : el.dataset.incl;
    });
    // koopvak
    document.querySelectorAll('.price-now--buy').forEach(function (el) {
      var i = el.querySelector('.price-now__int'), c = el.querySelector('.price-now__cents'); if (!i || !c) return;
      if (!i.dataset.incl) { i.dataset.incl = i.textContent; c.dataset.incl = c.textContent; }
      var cents = parse(i.dataset.incl + ',' + (c.dataset.incl.replace(',', '') || '-')); if (cents === null) return;
      if (excl) { var ex = Math.round(cents / 1.21); var s = fmt(ex).slice(1); i.textContent = s.split(',')[0]; c.textContent = ',' + s.split(',')[1]; }
      else { i.textContent = i.dataset.incl; c.textContent = c.dataset.incl; }
      var vat = el.parentNode.querySelector('.buy-price__vat'); if (vat) { if (!vat.dataset.incl) vat.dataset.incl = vat.textContent; vat.textContent = excl ? LBL : vat.dataset.incl; }
      var exl = el.parentNode.querySelector('.buy-price__ex'); if (exl) { if (!exl.dataset.incl) exl.dataset.incl = exl.textContent; exl.textContent = excl ? '€' + i.dataset.incl + c.dataset.incl + ' ' + LBL_IN : exl.dataset.incl; }
    });
    btns().forEach(function (btn) {
      btn.querySelectorAll('.btw-toggle__opt').forEach(function (o) { o.classList.toggle('is-on', (o.dataset.btw === 'excl') === excl); });
      btn.setAttribute('aria-pressed', excl ? 'true' : 'false');
    });
  }
  var excl = false; try { excl = localStorage.getItem(KEY) === 'excl'; } catch (e) {}
  function init() {
    var b = btns(); if (!b.length) return;
    b.forEach(function (btn) { btn.addEventListener('click', function () { excl = !excl; try { localStorage.setItem(KEY, excl ? 'excl' : 'incl'); } catch (e) {} apply(excl); }); });
    if (excl) apply(true);
    document.addEventListener('rabe:prices-updated', function () { if (excl) apply(true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* ---- uit sections/rabe-header (mega-menu) ---- */
;(() => {
    // Mega-menu met hover-intent (2026-09-14). Met puur :hover klapte het paneel dicht
    // als de muis snel of schuin van de kop naar het paneel ging: onderweg raakte hij een
    // buurkop, het strookje waar het paneel nog inschuift, of (op laptops) de tweede regel
    // van de navbalk met Advies/Contact. Nu blijft het paneel open zolang de muis binnen
    // de navbalk of het paneel is, en wisselt het pas als de muis even op een andere kop rust.
    const nav = document.querySelector('.site-header .site-nav');
    if (!nav || !window.matchMedia) return;
    const items = Array.from(nav.querySelectorAll(':scope > .site-nav__item--has-mega'));
    if (!items.length) return;
    const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    const SWITCH_DELAY = 160;
    const CLOSE_DELAY = 300;
    let current = null;
    let pending = null;
    let switchTimer = 0;
    let closeTimer = 0;
    const isTouch = (e) => e.pointerType === 'touch';
    const setOpen = (item) => {
      clearTimeout(switchTimer);
      clearTimeout(closeTimer);
      pending = null;
      if (current === item) return;
      if (current) current.classList.remove('is-open');
      current = item;
      if (item) item.classList.add('is-open');
    };
    const closeSoon = () => {
      clearTimeout(switchTimer);
      pending = null;
      clearTimeout(closeTimer);
      if (current) closeTimer = setTimeout(() => setOpen(null), CLOSE_DELAY);
    };
    const sync = () => {
      nav.classList.toggle('is-mega-js', mq.matches);
      if (!mq.matches) setOpen(null);
    };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);

    items.forEach((item) => {
      const link = item.querySelector(':scope > .site-nav__link');
      const panel = item.querySelector(':scope > .mega-menu');
      if (!link || !panel) return;
      link.addEventListener('pointerenter', (e) => {
        if (isTouch(e)) return;
        clearTimeout(closeTimer);
        if (!current) { setOpen(item); return; }
        clearTimeout(switchTimer);
        if (current === item) { pending = null; return; }
        pending = item;
        switchTimer = setTimeout(() => setOpen(item), SWITCH_DELAY);
      });
      link.addEventListener('pointerleave', (e) => {
        if (isTouch(e)) return;
        if (pending === item) { clearTimeout(switchTimer); pending = null; }
      });
      panel.addEventListener('pointerenter', (e) => {
        if (isTouch(e)) return;
        if (current === item) setOpen(item);
      });
    });
    // Links zonder paneel (Advies, Contact, ...) sluiten het open paneel.
    nav.querySelectorAll('.site-nav__link').forEach((link) => {
      if (link.closest('.site-nav__item--has-mega')) return;
      link.addEventListener('pointerenter', (e) => { if (!isTouch(e)) closeSoon(); });
    });
    nav.addEventListener('pointerenter', (e) => { if (!isTouch(e)) clearTimeout(closeTimer); });
    nav.addEventListener('pointerleave', (e) => { if (!isTouch(e)) closeSoon(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && current) setOpen(null); });
  })();

/* ---- uit sections/rabe-header (topbalk) ---- */
;(() => {
    const rotators = document.querySelectorAll('[data-topbar-rotator]');
    if (!rotators.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    rotators.forEach((rotator) => {
      const items = Array.from(rotator.querySelectorAll('[data-topbar-rotator-item]'));
      if (items.length < 2) return;

      let activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;
      items[activeIndex].classList.add('is-active');
      items.forEach((item, index) => item.setAttribute('aria-hidden', index === activeIndex ? 'false' : 'true'));

      window.setInterval(() => {
        const current = items[activeIndex];
        activeIndex = (activeIndex + 1) % items.length;
        const next = items[activeIndex];

        current.classList.remove('is-active');
        current.classList.add('is-exiting');
        current.setAttribute('aria-hidden', 'true');
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');

        window.setTimeout(() => current.classList.remove('is-exiting'), 450);
      }, 5000);
    });
  })();
  (() => {

    const form = document.querySelector('.header-search[data-predictive-url]');

    if (!form) return;

    const input = form.querySelector('[data-suggest-input]');

    const panel = form.querySelector('[data-suggest-panel]');

    const results = form.querySelector('[data-suggest-results]');

    const empty = form.querySelector('[data-suggest-empty]');

    const loading = form.querySelector('[data-suggest-loading]');

    const base = form.getAttribute('data-predictive-url') || '/search/suggest';

    if (!input || !panel || !results || !empty) return;



    let controller = null;

    let timer = null;

    let lastQuery = null;



    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };

    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };

    const showEmpty = () => {

      if (loading) loading.hidden = true;

      results.hidden = true;

      results.innerHTML = '';

      empty.hidden = false;

    };



    const fetchSuggest = (q) => {

      if (controller) controller.abort();

      controller = new AbortController();

      const url = base + '?q=' + encodeURIComponent(q)

        + '&section_id=rabe-predictive-search'

        + '&resources[type]=product,collection,article&resources[limit]=6';

      empty.hidden = true;

      if (loading) loading.hidden = false;

      fetch(url, { signal: controller.signal })

        .then((r) => (r.ok ? r.text() : ''))

        .then((html) => {

          if (loading) loading.hidden = true;

          const trimmed = html.trim();

          if (trimmed) {

            results.innerHTML = trimmed;

            results.hidden = false;

            empty.hidden = true;

          } else {

            showEmpty();

          }

        })

        .catch((err) => {

          if (err && err.name === 'AbortError') return;

          showEmpty();

        });

    };



    const onInput = () => {

      const q = input.value.trim();

      open();

      if (q.length < 2) { lastQuery = ''; clearTimeout(timer); showEmpty(); return; }

      if (q === lastQuery) return;

      lastQuery = q;

      clearTimeout(timer);

      timer = setTimeout(() => fetchSuggest(q), 180);

    };



    input.addEventListener('focus', () => {

      open();

      if (input.value.trim().length >= 2) { lastQuery = null; onInput(); } else { showEmpty(); }

    });

    input.addEventListener('input', onInput);

    input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); input.blur(); } });

    document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });

  })();

/* ---- uit snippets/rabe-ads-assets ---- */
;(() => {
    if (window.__rabeAds) return;
    window.__rabeAds = true;
    const used = new Set();
    // 2026-10-27 pdp: duizendtallen met een punt, zoals elders op de site (was '€7960,-')
    const money = (cents) => { const p = (cents / 100).toFixed(2).split('.'); const i = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return '€' + (p[1] === '00' ? i + ',-' : i + ',' + p[1]); };
    // halloween-2026 r11: staffelkorting ook hier (zelfde tags en eindtijd als snippets/rabe-halloween.liquid)
    const hwAan = false; /* Halloween 2026 is voorbij (eindtijd 1793660399) */
    const hwOff = (p) => { if (!hwAan) return 0; const t = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(/,\s*/); for (const b of [350, 200, 150, 75]) if (t.includes('halloween-2026-' + b)) return b * 100; return 0; };
    const prijs = (p) => { const o = hwOff(p); return o ? '<span class="hw-prijs">' + money(p.price - o) + '</span> <s class="hw-oud">' + money(p.price) + '</s>' : money(p.price); };

    const loadRecs = (box) => {
      const pid = box.dataset.pid;
      const base = box.dataset.recsUrl || '/recommendations/products.json';
      const more = box.parentElement ? box.parentElement.querySelector('[data-recs-more]') : null;
      const drop = () => {
        const s = box.closest('[data-adslot]');
        box.remove();
        if (more) more.remove();
        if (s && !s.querySelector('[data-ad], [data-recs-always]')) s.remove();
      };
      const fill = (el, items) => {
        el.innerHTML = items.map((p) => {
          let img = p.featured_image || '';
          if (img) img += (img.includes('?') ? '&' : '?') + 'width=320';
          return '<a class="rabe-recs__item" href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
            '<span class="rabe-recs__meta"><span class="rabe-recs__title">' + p.title.replace(/</g, '&lt;') +
            '</span><span class="rabe-recs__price">' + prijs(p) + '</span></span></a>';
        }).join('');
      };
      const show = (b1, b2) => {
        if (!b1.length) { drop(); return; }
        fill(box.querySelector('[data-recs-list]'), b1);
        if (more) {
          if (b2.length >= 3) { fill(more.querySelector('[data-recs-list]'), b2); more.hidden = false; }
          else more.remove();
        }
      };
      fetch(base + '?product_id=' + pid + '&limit=10&intent=related')
        .then((r) => (r.ok ? r.json() : Promise.reject()))
        .then((data) => {
          // 2026-10-27 pdp (punt 10): met data-strict alleen aanbevelingen met hetzelfde producttype of uit de categorie van data-alt-url
          const strict = box.hasAttribute('data-strict');
          const ptype = box.dataset.type || '';
          const raw = data.products || [];
          let all = raw, seen, picked, rest;
          const split = () => {
            // Bekijk ook eens: max 1 per titel-familie (eerste 2 woorden)
            seen = new Set(); picked = []; rest = [];
            all.forEach((p) => {
              const key = p.title.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').slice(0, 2).join(' ');
              if (!seen.has(key) && picked.length < 6) { seen.add(key); picked.push(p); }
              else rest.push(p);
            });
          };
          const keep = (okSet) => {
            all = strict ? raw.filter((p) => (ptype && p.type === ptype) || (okSet && okSet.has(p.handle))) : raw;
            split();
          };
          keep(null);
          const build = (broad) => {
            const used = new Set();
            const take = (arr, out, want) => {
              for (const p of arr) {
                if (out.length >= want) break;
                if (used.has(p.handle)) continue;
                used.add(p.handle);
                out.push(p);
              }
            };
            const b1 = [];
            take(picked, b1, 4);
            take(broad, b1, 6);
            take(picked, b1, 6);
            take(rest, b1, 6);
            const b2 = [];
            take(rest, b2, 6);
            take(broad, b2, 12);
            take(picked, b2, 12);
            show(b1, b2);
          };
          const altUrl = box.dataset.altUrl;
          if (!altUrl) { build([]); return; }
          const rootPath = base.replace(/\/recommendations\/products\.json$/, '');
          fetch(altUrl + '?limit=30')
            .then((r) => (r.ok ? r.json() : Promise.reject()))
            .then((cd) => {
              keep(new Set((cd.products || []).map((p) => p.handle)));
              const pool = (cd.products || []).filter((p) => String(p.id) !== String(pid));
              for (let i = pool.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [pool[i], pool[j]] = [pool[j], pool[i]];
              }
              build(pool.map((p) => ({
                title: p.title,
                handle: p.handle,
                url: rootPath + '/products/' + p.handle,
                featured_image: (p.images && p.images[0]) ? p.images[0].src : '',
                price: Math.round(parseFloat((p.variants && p.variants[0]) ? p.variants[0].price : '0') * 100),
                tags: p.tags,
              })));
            })
            .catch(() => build([]));
        })
        .catch(() => { drop(); });
    };

    document.querySelectorAll('[data-adslot]').forEach((slot) => {
      const ads = [...slot.querySelectorAll(':scope > [data-ad]')];
      const recs = slot.querySelector(':scope > [data-recs-always]');
      const pool = ads.filter((el) => !used.has(el.dataset.ad));
      if (pool.length) {
        const pick = pool[Math.floor(Math.random() * pool.length)];
        used.add(pick.dataset.ad);
        ads.forEach((el) => { if (el !== pick) el.remove(); });
        pick.hidden = false;
      } else {
        ads.forEach((el) => el.remove());
      }
      if (recs) loadRecs(recs);
      if (!pool.length && !recs) slot.remove();
    });
  })();

/* ---- uit snippets/rabe-compare-bar ---- */
;(() => {
    const KEY = 'rabeCompareV1';
    const MAX = 4;
    const isDe = (document.documentElement.lang || '').indexOf('de') === 0;
    const root = /^\/de(\/|$)/.test(location.pathname) ? '/de' : '';
    const bar = document.querySelector('[data-rcmp-bar]');
    const modal = document.querySelector('[data-rcmp-modal]');
    if (!bar || !modal) return;
    const src = document.querySelector('[data-rcmp-src]');
    const toggle = src ? src.querySelector('[data-rcmp-toggle]') : null;
    const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const save = (list) => localStorage.setItem(KEY, JSON.stringify(list));

    const renderBar = () => {
      const list = load();
      const items = bar.querySelector('[data-rcmp-items]');
      items.innerHTML = list.map((it, i) =>
        '<span class="rcmp-bar__item"><img src="' + it.i + '" alt=""><button type="button" data-rcmp-rm="' + i + '" aria-label="x">&times;</button></span>'
      ).join('');
      bar.querySelector('[data-rcmp-count]').textContent = list.length;
      bar.querySelector('[data-rcmp-open]').disabled = list.length < 2;
      bar.hidden = list.length === 0;
      if (toggle) toggle.checked = list.some((it) => it.h === src.dataset.handle);
    };

    if (toggle) {
      toggle.addEventListener('change', () => {
        let list = load();
        if (toggle.checked) {
          if (list.length >= MAX) {
            toggle.checked = false;
            alert(isDe ? 'Maximal ' + MAX + ' Artikel vergleichen. Entfernen Sie zuerst einen Artikel.' : 'Je kunt maximaal ' + MAX + ' artikelen vergelijken. Haal eerst een artikel weg.');
            return;
          }
          if (!list.some((it) => it.h === src.dataset.handle)) {
            list.push({ h: src.dataset.handle, t: src.dataset.title, i: src.dataset.img, p: src.dataset.price });
          }
        } else {
          list = list.filter((it) => it.h !== src.dataset.handle);
        }
        save(list); renderBar();
      });
    }

    bar.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-rcmp-rm]');
      if (rm) { const list = load(); list.splice(+rm.dataset.rcmpRm, 1); save(list); renderBar(); return; }
      if (e.target.closest('[data-rcmp-clear]')) { save([]); renderBar(); return; }
      if (e.target.closest('[data-rcmp-open]')) openModal();
    });

    modal.addEventListener('click', (e) => {
      if (e.target === modal || e.target.closest('[data-rcmp-close]')) modal.hidden = true;
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') modal.hidden = true; });

    const grabSpecs = (doc) => {
      const specs = [];
      let rows = doc.querySelectorAll('#sectie-specs .spec-table > div');
      if (!rows.length) rows = doc.querySelectorAll('.summary-table > div');
      rows.forEach((row) => {
        const dt = row.querySelector('dt'); const dd = row.querySelector('dd');
        if (dt && dd) specs.push([dt.textContent.trim(), dd.textContent.trim()]);
      });
      return specs;
    };

    const openModal = () => {
      const list = load();
      const holder = modal.querySelector('[data-rcmp-table]');
      holder.innerHTML = '<p class="rcmp-loading">' + (isDe ? 'Wird geladen ...' : 'Laden ...') + '</p>';
      modal.hidden = false;
      Promise.all(list.map((it) =>
        fetch(root + '/products/' + it.h)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return { it, specs: grabSpecs(doc) };
          })
          .catch(() => ({ it, specs: [] }))
      )).then((cols) => {
        const keys = [];
        cols.forEach((c) => c.specs.forEach(([k]) => { if (!keys.includes(k)) keys.push(k); }));
        let html = '<table class="rcmp-table"><thead><tr><th></th>';
        cols.forEach((c) => {
          html += '<th><span class="rcmp-prod"><img src="' + c.it.i + '" alt=""><a href="' + root + '/products/' + c.it.h + '">' + c.it.t.replace(/</g, '&lt;') + '</a><span class="rcmp-price">' + c.it.p + '</span></span></th>';
        });
        html += '</tr></thead><tbody>';
        keys.forEach((k) => {
          html += '<tr><td>' + k.replace(/</g, '&lt;') + '</td>';
          cols.forEach((c) => {
            const hit = c.specs.find(([sk]) => sk === k);
            html += '<td>' + (hit ? hit[1].replace(/</g, '&lt;') : '-') + '</td>';
          });
          html += '</tr>';
        });
        html += '</tbody></table>';
        holder.innerHTML = html;
      });
    };

    modal.hidden = true;
    renderBar();
  })();
